module.exports = __webpack_public_path__ + "img/jumuclogo.790b68f4.png";